var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background" },
    [
      _c(
        "v-row",
        { staticClass: "px-16 mb-12", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "page-header" }, [
                        _vm._v("AFS Carriers"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-4" },
                [
                  _c("label", { staticClass: "carrier-numbers" }, [
                    _vm._v(
                      _vm._s(_vm.formatNumber(_vm.filteredCarriers.length))
                    ),
                  ]),
                  _c("label", { staticClass: "ml-1 carrier-numbers-lbl" }, [
                    _vm._v("carrier results"),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("smart-btn", {
                        staticClass: "fr mt-n2",
                        class: { "w-100-pct": _vm.smAndDown },
                        attrs: {
                          label: "New Carrier",
                          icon: _vm.ic_plus,
                          "icon-class": "mr-3",
                          "icon-width": "12",
                          "icon-position": "left",
                          type: "primary",
                        },
                        on: { click: _vm.openNewCarrierPopup },
                      }),
                      _c(
                        "v-btn-toggle",
                        {
                          staticClass: "fr mt-n2",
                          class: {
                            "w-100-pct mt-4": _vm.smAndDown,
                            "mr-4": _vm.mdAndUp,
                          },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "base bg-white filters-btn left",
                              class: { "w-100-pct": _vm.smAndDown },
                              attrs: { outlined: "" },
                              on: {
                                click: function ($event) {
                                  _vm.showFilters = true
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "mr-2",
                                attrs: { width: "12", src: _vm.ic_filters },
                              }),
                              _vm._v(" Filters "),
                            ]
                          ),
                          _vm.mdAndUp
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "times-btn",
                                  on: { click: _vm.resetFilter },
                                },
                                [
                                  _c("img", {
                                    attrs: { width: "9", src: _vm.ic_times },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-6" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "carriers-grid-wrapper pl-3 br-10" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("afs-carriers-grid", {
                                on: {
                                  showEditDialog: _vm.showEditDialog,
                                  statusChanged: _vm.statusChanged,
                                  confirmDelete: _vm.confirmDelete,
                                  viewContacts: _vm.viewContacts,
                                  viewContracts: _vm.viewContracts,
                                  viewClients: _vm.viewClients,
                                  viewEquipmentTypes: _vm.viewEquipmentTypes,
                                  viewDashboard: _vm.viewDashboard,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.pagingLength > 1
                ? _c(
                    "v-row",
                    { staticClass: "mt-6", attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pl-0", attrs: { cols: "auto" } },
                        [
                          _c("v-pagination", {
                            staticClass: "pl-3",
                            attrs: {
                              length: _vm.pagingLength,
                              "total-visible": "10",
                            },
                            on: { input: _vm.pageChange },
                            model: {
                              value: _vm.currentPage,
                              callback: function ($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-snackbar",
                {
                  staticClass: "smart-snackbar",
                  scopedSlots: _vm._u([
                    {
                      key: "action",
                      fn: function (ref) {
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._b(
                              {
                                attrs: { color: "#007BFF", text: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.snackbar = false
                                  },
                                },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            [_vm._v(" Close ")]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.snackbar,
                    callback: function ($$v) {
                      _vm.snackbar = $$v
                    },
                    expression: "snackbar",
                  },
                },
                [
                  _c("img", {
                    staticClass: "success-icon",
                    attrs: { src: _vm.ic_green_success_checkmark },
                  }),
                  _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v("Loading Carriers"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", width: _vm.filtersWidth, eager: "" },
          model: {
            value: _vm.showFilters,
            callback: function ($$v) {
              _vm.showFilters = $$v
            },
            expression: "showFilters",
          },
        },
        [
          _c("carriers-filters", {
            on: {
              close: function ($event) {
                _vm.showFilters = false
              },
              applyFilters: _vm.applyFilters,
              clearFilters: _vm.resetFilter,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "546px" },
          model: {
            value: _vm.displayConfirmDelete,
            callback: function ($$v) {
              _vm.displayConfirmDelete = $$v
            },
            expression: "displayConfirmDelete",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "br-10" },
            [
              _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "py-10 px-10 ta-c",
                      attrs: { row: "", wrap: "" },
                    },
                    [
                      _c("v-flex", [
                        _c("label", { staticClass: "are-your-sure-lbl" }, [
                          _vm._v(
                            "Are you sure you want to delete carrier? This cannot be undone!"
                          ),
                        ]),
                      ]),
                      _c("v-flex", { staticClass: "mt-6" }, [
                        _c("label", { staticClass: "delete-label" }, [
                          _vm._v(
                            "Deleting this carrier will remove all information from our database."
                          ),
                        ]),
                      ]),
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-layout",
                            { staticClass: "mt-12 mb-2" },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("smart-btn", {
                                    staticClass: "fr mr-4",
                                    attrs: { type: "dismiss", label: "Cancel" },
                                    on: {
                                      click: function ($event) {
                                        _vm.displayConfirmDelete = false
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                [
                                  _c("smart-btn", {
                                    staticClass: "fl ml-4",
                                    attrs: {
                                      type: "danger",
                                      label: "Delete",
                                      loading: _vm.deleting,
                                    },
                                    on: { click: _vm.softDeleteCarrier },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px", scrollable: "", eager: "" },
          model: {
            value: _vm.displayEditCarrierPopup,
            callback: function ($$v) {
              _vm.displayEditCarrierPopup = $$v
            },
            expression: "displayEditCarrierPopup",
          },
        },
        [
          _c("add-edit-carrer", {
            on: {
              close: function ($event) {
                _vm.displayEditCarrierPopup = false
              },
              carrierSaved: _vm.carrierSaved,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px", scrollable: "", eager: "" },
          on: { close: _vm.onAddCarrierPopupClose },
          model: {
            value: _vm.displayAddCarrierPopup,
            callback: function ($$v) {
              _vm.displayAddCarrierPopup = $$v
            },
            expression: "displayAddCarrierPopup",
          },
        },
        [
          _c("add-edit-carrer", {
            attrs: { new: true },
            on: {
              close: function ($event) {
                _vm.displayAddCarrierPopup = false
              },
              carrierSaved: _vm.carrierSaved,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }